export const BROWSE_STRATEGIES_EVENT_NAMES = {
  VIEWED_PAGE: 'Viewed Browse Strategies',
  FILTERED_RESULTS: 'Filtered Strategy Results',
  CLICKED_RESULT: 'Clicked Strategy Result'
}

export const STRATEGY_WIZARD_EVENT_NAMES = {
  VIEWED_PAGE: 'Viewed Strategy Wizard',
  SUBMITTED: 'Submitted Strategy Wizard'
}
